$(document).ready(function () {
    // Get the theme URL
    var url;
    if ($('meta[name=pluginURL]').attr("content")) {
        url = $('meta[name=pluginURL]').attr("content");
    } else {
        // Fallback: infer plugin base URL from the current script src
        var scriptSrc = $('script[src*="/dist/main.js"]').last().attr('src') || '';
        url = scriptSrc ? scriptSrc.replace(/\/dist\/main\.js(?:\?.*)?$/, '') : '';
    }

    // Detect login page
    if ($("body").hasClass("login")) {

        $("#login").prepend('<img class="uwu-logo" src="' + url + '/dist/images/uwu-logo.svg" alt="United Workers Union Logo">');
    }

    // Remove the YOURLS header
    $("header[role=banner]").hide();
    $("header[role=banner]").remove();

    // remove help link in nav
    $('#admin_menu_help_link').remove();

    // Add branded header
    if (!$("body").hasClass("login")) {
        $("body").prepend($('<header class="site-header">').load(url + '/inc/header.php', function () {
            // run add header content function
            uwu_add_header_content();

            $('body').prepend('<div class="nav-overlay"></div>');
            // Nav icon toggle
            $('#menu-icon').click(function () {
                $(this).toggleClass('open');
                $('nav, .nav-overlay').toggleClass('nav-open');
            });

            if ($("body").hasClass("index")) {
                var originalNewUrl = $("#new_url");
                if (originalNewUrl.length && !originalNewUrl.parent().hasClass('form-wrap')) {
                    originalNewUrl.show().wrap('<div class="form-wrap"></div>');
                }
            }
        }));
    }


    // Update favicon
    $('link[rel="shortcut icon"]').attr('href', url + "/dist/images/favicon.ico")

    // wrap index table in table-responsive

    $('#main_table').wrap("<div class='table-responsive'></div>");
    $("#main_table").addClass("table");

    // handle p tags

    $("#wrap > p").each(function () {
        if (/Display/.test($(this).text()) || /Overall/.test($(this).text())) {
            // Move info on index page to the bottom
            $("main").append("<p>" + $(this).html() + "</p>");
            $(this).remove();
        }
    });

    // wrap div around data tabs so can scroll on small screens

    $('#stat_tab_stats, #stat_tab_location, #stat_tab_sources, #stat_tab_share').wrapAll('<div class="tab-scroll"></div>');

    // remove help link in nav
    $('#admin_menu_help_link').remove();


    // add header function

    function uwu_add_header_content() {
        $('.site-header').append('<div class="uwu-logo-wrap"><a class="uwu-logo-link" href="https://unitedworkers.org.au" target="_blank"><img class="uwu-logo" src="' + url + '/dist/images/uwu-logo-wh.svg" alt="United Workers Union Logo"></a></div>');
    }





});// end document.ready
